const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

export function getRedirectPath(): string | null {
  return localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
}

export function setRedirectPath(path: string): void {
  localStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, path);
}

export function clearRedirectPath(): void {
  localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
}
